import { CaseCondition, CaseConditionForReact } from './Interfaces';

export class RuleSetAssignmentCriteria {
  id: string;
  ruleSetId: string;
  caseConditions: CaseCondition[];

  constructor(ruleCriteria: RuleSetAssignmentCriteriaForReact) {
    this.id = ruleCriteria.id;
    this.ruleSetId = ruleCriteria.ruleSetId;
    this.caseConditions = [];
    for (const caseCondition of ruleCriteria.caseConditions || []) {
      this.caseConditions.push(new CaseCondition(caseCondition));
    }
  }
}

export class RuleSetAssignmentCriteriaForReact {
  id: string;
  ruleSetId: string;
  caseConditions: CaseConditionForReact[];

  constructor(ruleCriteria: RuleSetAssignmentCriteria) {
    this.id = ruleCriteria.id;
    this.ruleSetId = ruleCriteria.ruleSetId;
    this.caseConditions = [];
    for (const caseCondition of ruleCriteria.caseConditions || []) {
      this.caseConditions.push(new CaseConditionForReact(caseCondition));
    }
  }
}
